import * as React from "react";

export const Star = () => (
    <g fill="none">
        <path
            d="M7.52242 1.9851C7.63461 1.60146 8.17807 1.60147 8.29026 1.98509L9.2659 5.32123C9.41909 5.84502 9.82868 6.25462 10.3525 6.4078L13.6886 7.38344C14.0722 7.49564 14.0722 8.03909 13.6886 8.15128L10.3525 9.12693C9.82868 9.28011 9.41909 9.6897 9.2659 10.2135L8.29026 13.5496C8.17807 13.9333 7.63461 13.9333 7.52242 13.5496L6.54678 10.2135C6.3936 9.6897 5.984 9.28011 5.46021 9.12693L2.12407 8.15128C1.74044 8.03909 1.74045 7.49564 2.12407 7.38345L5.46021 6.4078C5.984 6.25462 6.3936 5.84503 6.54678 5.32123L7.52242 1.9851Z"
            stroke="currentColor"
            strokeWidth="1.2"
        />
        <path
            d="M3.89099 4.45957C3.89099 4.45957 4.91049 4.52869 4.84196 3.5686"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            d="M11.91 4.45957C11.91 4.45957 10.8905 4.52869 10.9591 3.5686"
            stroke="currentcolor"
            strokeLinecap="round"
        />
        <path
            d="M3.84521 10.8847C3.84521 10.8847 4.86471 10.8155 4.79619 11.7756"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            d="M11.91 10.8847C11.91 10.8847 10.8905 10.8155 10.9591 11.7756"
            stroke="currentColor"
            strokeLinecap="round"
        />
    </g>
);
